import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import API_URL from '../../config/api';

const STEPS = [
  { id: 1, name: 'Orçamento e Imposto', icon: '💰' },
  { id: 2, name: 'Cliente', icon: '👤' },
  { id: 3, name: 'Itens', icon: '📦' },
  { id: 4, name: 'Frete', icon: '🚚' },
  { id: 5, name: 'Contrato', icon: '📄' },
  { id: 6, name: 'Observações', icon: '📝' },
  { id: 7, name: 'Resumo', icon: '✅' },
];

const formatBRL = (value) => {
  if (typeof value !== 'number') return 'R$ 0,00';
  return `R$ ${value.toFixed(2).replace('.', ',')}`;
};

// Helper para formatar CEP
const formatCEP = (cep) => {
  if (!cep) return '';
  const cleaned = cep.replace(/\D/g, '');
  if (cleaned.length === 8) {
    return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
  }
  return cep;
};

const Step1BudgetTax = ({ formData, setFormData, errors, setErrors, filiais, setFiliais, usuarios, setUsuarios }) => {
  const [indicadores, setIndicadores] = useState([]);

  useEffect(() => {
    const fetchIndicadores = async () => {
      try {
        const response = await fetch(`${API_URL}/api/indicadores`);
        if (!response.ok) {
          throw new Error('Failed to fetch indicadores');
        }
        const data = await response.json();
        setIndicadores(data.indicadores || []);
      } catch (error) {
        console.error('Error fetching indicadores:', error);
      }
    };
    fetchIndicadores();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      if (name === 'tipoVendaMaterial') {
        setFormData(prev => ({ ...prev, tipoVendaMaterial: checked }));
      } else if (name === 'tipoVendaServico') {
        setFormData(prev => ({ ...prev, tipoVendaServico: checked }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleAddIndicator = () => {
    setFormData(prev => ({
      ...prev,
      indicadores: [...(prev.indicadores || []), { simNao: 'Não', nome: '', code: '', valor: '', valorTipo: '%' }]
    }));
  };

  const handleRemoveIndicator = (index) => {
    setFormData(prev => ({
      ...prev,
      indicadores: prev.indicadores.filter((_, i) => i !== index)
    }));
  };

  const handleIndicatorChange = (index, field, value) => {
    if (field === 'code') {
      const selectedInd = indicadores.find(ind => ind.code === value);
      setFormData(prev => ({
        ...prev,
        indicadores: prev.indicadores.map((ind, i) =>
          i === index ? { ...ind, code: value, nome: selectedInd ? selectedInd.name : '' } : ind
        )
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        indicadores: prev.indicadores.map((ind, i) =>
          i === index ? { ...ind, [field]: value } : ind
        )
      }));
    }
  };

  return (
        <div className="bg-white p-4 sm:p-6 rounded-md shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Tipo de Venda */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipo de venda: <span className="text-red-500"></span>
          </label>
          <div className="flex space-x-4">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="tipoVendaMaterial"
                checked={formData.tipoVendaMaterial}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2">Material</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="tipoVendaServico"
                checked={formData.tipoVendaServico}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2">Serviço</span>
            </label>
          </div>
        </div>

        {/* Contribuinte de ICMS */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Contribuinte de ICMS: <span className="text-red-500"></span>
          </label>
          <div className="flex space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="contribuinteICMS"
                value="Sim"
                checked={formData.contribuinteICMS === 'Sim'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">Sim</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="contribuinteICMS"
                value="Não"
                checked={formData.contribuinteICMS === 'Não'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">Não</span>
            </label>
          </div>
        </div>

        {/* Contra Aviso */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Contra Aviso:
          </label>
          <div className="flex space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="contraAviso"
                value="Sim"
                checked={formData.contraAviso === 'Sim'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">Sim</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="contraAviso"
                value="Não"
                checked={formData.contraAviso === 'Não'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">Não</span>
            </label>
          </div>
        </div>

        {/* Indicadores múltiplos */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Indicadores:
          </label>
          <div className="space-y-4">
            {formData.indicadores && formData.indicadores.length > 0 ? (
              formData.indicadores.map((indicador, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <select
                    value={indicador.code}
                    onChange={(e) => handleIndicatorChange(index, 'code', e.target.value)}
                    className="w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Selecione um indicador</option>
                    {indicadores.map(ind => (
                      <option key={ind.code} value={ind.code}>
                        {ind.name}
                      </option>
                    ))}
                  </select>
                  <input
                    type="number"
                    value={indicador.valor}
                    onChange={(e) => handleIndicatorChange(index, 'valor', e.target.value)}
                    placeholder="Valor"
                    className="w-1/4 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    min="0"
                    step="0.01"
                  />
                  <select
                    value={indicador.valorTipo}
                    onChange={(e) => handleIndicatorChange(index, 'valorTipo', e.target.value)}
                    className="w-1/4 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="%">%</option>
                    <option value="R$">R$</option>
                  </select>
                  <button
                    type="button"
                    onClick={() => handleRemoveIndicator(index)}
                    className="text-red-600 hover:text-red-900 px-2 py-1 rounded-md border border-red-600"
                    title="Remover indicador"
                  >
                    &times;
                  </button>
                </div>
              ))
            ) : (
              <p className="text-gray-500">Nenhum indicador adicionado.</p>
            )}
            <button
              type="button"
              onClick={handleAddIndicator}
              className="mt-2 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
            >
              +1
            </button>
          </div>
        </div>

        {/* Vendedor */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Vendedor: <span className="text-red-500">*</span>
          </label>
          <select
            name="vendedor"
            value={formData.vendedor}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Selecione um vendedor</option>
            {usuarios && usuarios.map(user => (
              <option key={user.id} value={user.nome || user.email}>
                {user.nome || user.email}
              </option>
            ))}
          </select>
          {errors.vendedor && <p className="text-red-500 text-sm mt-1">{errors.vendedor}</p>}
        </div>

        {/* Filial */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Filial: <span className="text-red-500">*</span>
          </label>
          <select
            name="filial"
            value={formData.filial}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Selecione uma filial</option>
            {filiais && filiais.map(filial => (
              <option key={filial.id} value={filial.filial}>
                {filial.filial}
              </option>
            ))}
          </select>
          {errors.filial && <p className="text-red-500 text-sm mt-1">{errors.filial}</p>}
        </div>

        {/* Condição de pagamento */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Condição de pagamento: <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="condicaoPagamento"
            value={formData.condicaoPagamento}
            onChange={handleInputChange}
            placeholder="Digite a condição de pagamento"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {errors.condicaoPagamento && <p className="text-red-500 text-sm mt-1">{errors.condicaoPagamento}</p>}
        </div>

        {/* Forma de pagamento */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Forma de pagamento: <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="formaPagamento"
            value={formData.formaPagamento}
            onChange={handleInputChange}
            placeholder="Digite a forma de pagamento"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {errors.formaPagamento && <p className="text-red-500 text-sm mt-1">{errors.formaPagamento}</p>}
        </div>
      </div>
    </div>
  );
};

const Step2Client = ({ formData, setFormData, errors }) => {
  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [showClientModal, setShowClientModal] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cliente' && value === '') {
      // Clear client-related fields when cliente input is cleared
      setFormData(prev => ({
        ...prev,
        cliente: '',
        logradouro: '',
        bairro: '',
        cep: '',
        numero: '',
        cidade: '',
        complemento: '',
        estado: '',
        vendedor: '',
        tipoCliente: '',
        cpf: '',
        cnpj: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Function to fetch address data from CEP
  const fetchAddressFromCEP = async (cep) => {
    if (!cep || cep.length !== 8) return;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        alert('CEP não encontrado. Verifique o CEP digitado.');
        return;
      }

      setFormData(prev => ({
        ...prev,
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || '',
      }));
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      alert('Erro ao buscar informações do CEP. Tente novamente.');
    }
  };

  // Handle CEP input change with auto-fill
  const handleCEPChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    setFormData(prev => ({
      ...prev,
      cep: value
    }));

    // Auto-fill when CEP is complete (8 digits)
    if (value.length === 8) {
      fetchAddressFromCEP(value);
    }
  };

  // Function to format CPF
  const formatCPF = (value) => {
    if (!value) return '';
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, '').slice(0, 11);
    // Format as XXX.XXX.XXX-XX
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 9);
    const part4 = digits.slice(9, 11);
    let formatted = part1;
    if (part2) formatted += '.' + part2;
    if (part3) formatted += '.' + part3;
    if (part4) formatted += '-' + part4;
    return formatted;
  };

  // Function to format CNPJ
  const formatCNPJ = (value) => {
    if (!value) return '';
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, '').slice(0, 14);
    // Format as XX.XXX.XXX/XXXX-XX
    const part1 = digits.slice(0, 2);
    const part2 = digits.slice(2, 5);
    const part3 = digits.slice(5, 8);
    const part4 = digits.slice(8, 12);
    const part5 = digits.slice(12, 14);
    let formatted = part1;
    if (part2) formatted += '.' + part2;
    if (part3) formatted += '.' + part3;
    if (part4) formatted += '/' + part4;
    if (part5) formatted += '-' + part5;
    return formatted;
  };

  // Function to search clients
  // Debounce timer for client search using useRef to persist across renders
  const clientSearchTimeout = React.useRef(null);

  const searchClients = async (searchTerm) => {
    if (!searchTerm.trim()) {
      setClients([]);
      return;
    }

    setLoadingClients(true);
    try {
      // Adjusted query parameter to 'search' as a single parameter for backend compatibility
      const response = await fetch(`${API_URL}/api/clients?search=${encodeURIComponent(searchTerm)}`);
      if (!response.ok) {
        throw new Error('Failed to fetch clients');
      }
      const data = await response.json();
      setClients(data.clients || []);
    } catch (error) {
      console.error('Error searching clients:', error);
      alert('Erro ao buscar clientes: ' + error.message);
      setClients([]);
    } finally {
      setLoadingClients(false);
    }
  };

  // Debounced version of searchClients using useRef
  const debouncedSearchClients = (searchTerm) => {
    if (clientSearchTimeout.current) {
      clearTimeout(clientSearchTimeout.current);
    }
    clientSearchTimeout.current = setTimeout(() => {
      searchClients(searchTerm);
    }, 300);
  };

  // Function to handle client selection
  const handleClientSelect = (client) => {
    // Map backend tipo to form options
    let adjustedTipo = '';
    if (client.tipo === 'Física') {
      adjustedTipo = 'Pessoa Física';
    } else if (client.tipo === 'Jurídica') {
      adjustedTipo = 'Pessoa Jurídica';
    } else if (client.cpf_cnpj) {
      // Fallback detection based on length
      const digitsOnly = client.cpf_cnpj.replace(/\D/g, '');
      if (digitsOnly.length === 11) {
        adjustedTipo = 'Pessoa Física';
      } else if (digitsOnly.length === 14) {
        adjustedTipo = 'Pessoa Jurídica';
      }
    }
    const cpfCnpj = client.cpf_cnpj || '';
    let cpf = '';
    let cnpj = '';
    if (adjustedTipo === 'Pessoa Física') {
      cpf = formatCPF(cpfCnpj);
    } else if (adjustedTipo === 'Pessoa Jurídica') {
      cnpj = formatCNPJ(cpfCnpj);
    }
    setFormData(prev => ({
      ...prev,
      cliente: `${client.code} - ${client.name}`,
      logradouro: client.logradouro || '',
      bairro: client.bairro || '',
      cep: client.cep || '',
      numero: client.numero || '',
      cidade: client.cidade || '',
      complemento: client.complemento || '',
      estado: client.estado || '',
      vendedor: prev.vendedor || client.representante || '',
      tipoCliente: adjustedTipo,
      cpf: cpf,
      cnpj: cnpj,
      inscricaoEstadual: client.inscricaoEstadual || '',
      inscricaoMunicipal: client.inscricaoMunicipal || '',
    }));
    setShowClientModal(false);
    setClientSearchTerm('');
    setClients([]);
  };

  // Function to open client search modal
  const handleClientSearchButtonClick = () => {
    setShowClientModal(true);
    setClientSearchTerm('');
    setClients([]);
  };

  return (
    <div className="space-y-6">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    {/* Cliente */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Cliente
      </label>
      <div className="flex gap-2">
        <input
          type="text"
          name="cliente"
          value={formData.cliente}
          onChange={handleInputChange}
          placeholder="191786 - ALMIR DOMINGO MIOTTI"
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleClientSearchButtonClick}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          title="Buscar cliente"
        >
          🔍
        </button>
      </div>
      {errors.cliente && <p className="text-red-500 text-sm mt-1">{errors.cliente}</p>}
    </div>
    {/* Tipo de cliente */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipo de cliente:
          </label>
          <select
            name="tipoCliente"
            value={formData.tipoCliente}
            onChange={(e) => {
              const value = e.target.value;
              setFormData(prev => ({
                ...prev,
                tipoCliente: value,
                // Clear CPF/CNPJ when tipoCliente changes
                cpf: '',
                cnpj: ''
              }));
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Selecione o tipo de cliente</option>
            <option value="Pessoa Física">Pessoa Física</option>
            <option value="Pessoa Jurídica">Pessoa Jurídica</option>
          </select>
        </div>

        {/* CPF or CNPJ input */}
        <div>
          {formData.tipoCliente === 'Pessoa Física' && (
            <>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                CPF:
              </label>
              <input
                type="text"
                name="cpf"
                value={formData.cpf}
                onChange={(e) => {
                  const formatted = formatCPF(e.target.value);
                  setFormData(prev => ({ ...prev, cpf: formatted }));
                }}
                maxLength={14}
                placeholder="000.000.000-00"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </>
          )}
          {formData.tipoCliente === 'Pessoa Jurídica' && (
            <>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                CNPJ:
              </label>
              <input
                type="text"
                name="cnpj"
                value={formData.cnpj}
                onChange={(e) => {
                  const formatted = formatCNPJ(e.target.value);
                  setFormData(prev => ({ ...prev, cnpj: formatted }));
                }}
                maxLength={18}
                placeholder="00.000.000/0000-00"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </>
          )}
        </div>

        {/* Inscrição Estadual */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Inscrição Estadual:
          </label>
          <input
            type="text"
            name="inscricaoEstadual"
            value={formData.inscricaoEstadual || ''}
            onChange={handleInputChange}
            placeholder="Inscrição Estadual"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

    {/* Inscrição Municipal */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Inscrição Municipal:
      </label>
      <input
        type="text"
        name="inscricaoMunicipal"
        value={formData.inscricaoMunicipal || ''}
        onChange={handleInputChange}
        placeholder="Inscrição Municipal"
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

        {/* Client Search Modal */}
        {showClientModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-md p-4 sm:p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Buscar Cliente</h2>
                <button
                  onClick={() => setShowClientModal(false)}
                  className="text-gray-600 hover:text-gray-900 text-2xl font-bold"
                  title="Fechar"
                >
                  &times;
                </button>
              </div>
              <input
                type="text"
                value={clientSearchTerm}
              onChange={(e) => {
                setClientSearchTerm(e.target.value);
                debouncedSearchClients(e.target.value);
              }}
                placeholder="Digite o nome ou código do cliente"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
                autoFocus
              />
              {loadingClients ? (
                <p>Carregando...</p>
              ) : (
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Setor</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Cidade</th>
                      <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 max-h-96 overflow-y-auto">
                    {clients.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                          Nenhum cliente encontrado
                        </td>
                      </tr>
                    ) : (
                      clients.map(client => (
                        <tr key={client.id} className="hover:bg-gray-100 cursor-pointer" onClick={() => handleClientSelect(client)}>
                          <td className="px-6 py-4 whitespace-nowrap">{client.code}</td>
                          <td className="px-6 py-4 whitespace-nowrap">{client.name}</td>
                          <td className="px-6 py-4 whitespace-nowrap">{client.setor}</td>
                          <td className="px-6 py-4 whitespace-nowrap">{client.cidade}</td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClientSelect(client);
                              }}
                              className="text-blue-600 hover:text-blue-900"
                            >
                  Selecionar
                </button>
              </td>
            </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}

        {/* Endereço de entrega */}
        <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Logradouro
            </label>
            <input
              type="text"
              name="logradouro"
              value={formData.logradouro || ''}
              onChange={handleInputChange}
              placeholder="Logradouro"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Bairro
            </label>
            <input
              type="text"
              name="bairro"
              value={formData.bairro || ''}
              onChange={handleInputChange}
              placeholder="Bairro"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Cep
            </label>
            <input
              type="text"
              name="cep"
              value={formatCEP(formData.cep) || ''}
              onChange={handleCEPChange}
              placeholder="Cep"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Número
            </label>
            <input
              type="text"
              name="numero"
              value={formData.numero || ''}
              onChange={handleInputChange}
              placeholder="Número"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Cidade
            </label>
            <input
              type="text"
              name="cidade"
              value={formData.cidade || ''}
              onChange={handleInputChange}
              placeholder="Cidade"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Complemento
            </label>
            <input
              type="text"
              name="complemento"
              value={formData.complemento || ''}
              onChange={handleInputChange}
              placeholder="Complemento"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Estado
            </label>
            <input
              type="text"
              name="estado"
              value={formData.estado || ''}
              onChange={handleInputChange}
              placeholder="Estado"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Comprador */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Comprador:
          </label>
          <input
            type="text"
            name="comprador"
            value={formData.comprador}
            onChange={handleInputChange}
            placeholder="Ex: PAULO, PEDRO"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Ordem de compra */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ordem de compra:
          </label>
          <input
            type="text"
            name="ordemCompra"
            value={formData.ordemCompra}
            onChange={handleInputChange}
            placeholder="Ex: K57821"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>
  );
};




// Step Components
const Step3Items = ({ formData, setFormData, errors, indicadores }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [quantity, setQuantity] = useState('');
  const [unitMeasure, setUnitMeasure] = useState('M');
  const [unitValue, setUnitValue] = useState('');
  const [observation, setObservation] = useState('');

  const [icmsPercentInput, setIcmsPercentInput] = useState(formData.icmsPercent || '');

  // New states for "Relação de peças"
  const [showPieceRelation, setShowPieceRelation] = useState(false);
  const [isPieceRelationDisabled, setIsPieceRelationDisabled] = useState(false);
  const [dimensions, setDimensions] = useState([]);
  const [currentLength, setCurrentLength] = useState('1000');
  const [currentWidth, setCurrentWidth] = useState('1000');
  const [currentPieces, setCurrentPieces] = useState('');
  const [editIndex, setEditIndex] = useState(-1);

  // Disable checkbox if unitMeasure is in this list
const disabledUnits = React.useMemo(() => ["UN", "PC", "CT", "CX", "M3"], []);

  React.useEffect(() => {
    if (disabledUnits.includes(unitMeasure)) {
      setIsPieceRelationDisabled(true);
      setShowPieceRelation(false);
    } else {
      setIsPieceRelationDisabled(false);
    }
  }, [unitMeasure, disabledUnits]);

  const [over1, setOver1] = useState(0);
  const [over1Type, setOver1Type] = useState('%');
  const [desconto, setDesconto] = useState(0);
  const [descontoType, setDescontoType] = useState('%');

  // Product search modal states
  const [showProductModal, setShowProductModal] = useState(false);
  const [productSearchTerm, setProductSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [ncm, setNcm] = useState('');
  const [selectedProductIpi, setSelectedProductIpi] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductCode, setSelectedProductCode] = useState('');
  const [isUnitMeasureDisabled, setIsUnitMeasureDisabled] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);







  const resetFields = () => {
    setSearchTerm('');
    setQuantity('');
    setUnitValue('');
    setObservation('');
    setOver1(0);
    setOver1Type('%');
    setIcmsPercentInput('');
    setShowPieceRelation(false);
    setDimensions([]);
    setCurrentLength('1000');
    setCurrentWidth('1000');
    setCurrentPieces('');
    setEditIndex(-1);
    setEditingItemId(null);
    setIsProductSelected(false);
    setIsUnitMeasureDisabled(false);
  };

  const handleAddDimension = () => {
    if (!currentLength || !currentWidth || !currentPieces) {
      alert('Preencha comprimento, largura e quantidade de peças');
      return;
    }
    const lengthNum = parseFloat(currentLength);
    const widthNum = parseFloat(currentWidth);
    const piecesNum = parseInt(currentPieces, 10);
    if (isNaN(lengthNum) || isNaN(widthNum) || isNaN(piecesNum) || lengthNum <= 0 || widthNum <= 0 || piecesNum <= 0) {
      alert('Valores inválidos para comprimento, largura ou quantidade de peças');
      return;
    }

    const newDimension = {
      length: lengthNum,
      width: widthNum,
      pieces: piecesNum,
      observacao: observation || ''
    };

    if (editIndex >= 0) {
      // Edit existing dimension
      const updated = [...dimensions];
      updated[editIndex] = newDimension;
      setDimensions(updated);
      setEditIndex(-1);
    } else {
      // Add new dimension
      setDimensions([...dimensions, newDimension]);
    }

    setCurrentLength('1000');
    setCurrentWidth('1000');
    setCurrentPieces('');
    setObservation('');
  };

  const handleDeleteDimension = (index) => {
    setDimensions(dimensions.filter((_, i) => i !== index));
  };

  const totalMeterage = dimensions.reduce((sum, dim) => sum + (dim.length / 1000) * (dim.width / 1000) * dim.pieces, 0);

  const handleAddItem = () => {
    if (!searchTerm || (showPieceRelation ? totalMeterage <= 0 : !quantity) || !unitValue) {
      alert('Preencha os campos obrigatórios: Item, Quantidade e Valor Unitário');
      return;
    }

    const itemQuantity = showPieceRelation ? totalMeterage : parseFloat(quantity);
    let itemUnitValue = parseFloat(unitValue);

    if (isNaN(itemQuantity) || itemQuantity <= 0 || isNaN(itemUnitValue) || itemUnitValue <= 0) {
      alert('Valores inválidos para quantidade ou valor unitário');
      return;
    }

    // Apply over to unit value
    let valorVenda = itemUnitValue;
    if (over1Type === '%') {
      valorVenda = valorVenda * (1 + over1 / 100);
    } else {
      valorVenda = valorVenda + over1;
    }
    const valorTotal = itemQuantity * valorVenda;

    const newItem = {
      id: editingItemId || Date.now(),
      produto: searchTerm,
      quantidade: itemQuantity,
      unidade: unitMeasure,
      valorTabela: itemUnitValue,
      observacao: observation,
      over1: over1,
      over1Type: over1Type,
      icms: icmsPercentInput,
      ipi: selectedProductIpi,
      pieceRelation: showPieceRelation,
      dimensions: showPieceRelation ? dimensions : [],
      valorVenda: valorVenda,
      valorTotal: valorTotal,
      ncm: ncm,
      code: selectedProductCode
    };

    if (editingItemId) {
      // Update existing item
      setFormData(prev => ({
        ...prev,
        items: prev.items.map(item => item.id === editingItemId ? newItem : item)
      }));
    } else {
      // Add new item
      setFormData(prev => ({
        ...prev,
        items: [...(prev.items || []), newItem]
      }));
    }

    // Reset fields
    resetFields();
  };

  const handleEditDimension = (index) => {
    const dim = dimensions[index];
    setCurrentLength(dim.length.toString());
    setCurrentWidth(dim.width ? dim.width.toString() : '1000');
    setCurrentPieces(dim.pieces.toString());
    setEditIndex(index);
  };

  const handleAplicar = () => {
    setFormData(prev => {
      const updatedItems = prev.items.map(item => {
        let baseValue = item.valorTabela || 0;
        // Apply over1
        if (over1Type === '%') {
          baseValue = baseValue * (1 + over1 / 100);
        } else {
          baseValue = baseValue + over1;
        }
        const valorVenda = baseValue;
        const valorTotal = valorVenda * (item.quantidade || 0);
        return {
          ...item,
          over1: over1,
          over1Type: over1Type,
          valorVenda: valorVenda,
          valorTotal: valorTotal
        };
      });
      return {
        ...prev,
        items: updatedItems
      };
    });
    setOver1(0);
  };

  const handleAplicarICMS = () => {
    setFormData(prev => {
      const updatedItems = prev.items.map(item => ({
        ...item,
        icms: icmsPercentInput
      }));
      return {
        ...prev,
        items: updatedItems
      };
    });
    setIcmsPercentInput('');
  };

  // New function to recalculate freight distribution among items
  const handleRecalcularFrete = () => {
    if (!formData.items || formData.items.length === 0) {
      alert('Não há itens para recalcular o frete');
      return;
    }

    // Calculate total embedded freight from all items
    const totalFreteEmbutido = formData.items.reduce((acc, item) => acc + (item.freteEmbutidoItem || 0), 0);

    if (totalFreteEmbutido <= 0) {
      alert('Não há frete embutido para recalcular');
      return;
    }

    // Calculate total value of all items based on base value (valorTabela + over1)
    const totalBaseValueItems = formData.items.reduce((total, item) => {
      const valorTabela = item.valorTabela || 0;
      const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
      const baseValue = valorTabela + over;
      return total + baseValue * item.quantidade;
    }, 0);

    if (totalBaseValueItems <= 0) {
      alert('O valor total dos itens deve ser maior que zero para recalcular o frete');
      return;
    }

    // Distribute embedded freight proportionally to each item based on base value
    const updatedItems = formData.items.map(item => {
      const valorTabela = item.valorTabela || 0;
      const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
      const baseValue = valorTabela + over;

      const proportionalFreight = (baseValue * item.quantidade / totalBaseValueItems) * totalFreteEmbutido;
      const newUnitValue = baseValue + (proportionalFreight / item.quantidade);
      const newTotalValue = newUnitValue * item.quantidade;

      return {
        ...item,
        valorVenda: newUnitValue,
        valorTotal: newTotalValue,
        freteEmbutidoItem: proportionalFreight
      };
    });

    // Update form data with new item values and freight calculations
    setFormData(prev => ({
      ...prev,
      items: updatedItems
    }));

    alert(`Frete recalculado com sucesso! Total frete embutido: R$ ${totalFreteEmbutido.toFixed(2)}`);
  };

  // Function to search products
  const searchProducts = async (searchTerm) => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      setCurrentPage(1);
      return;
    }

    setLoadingProducts(true);
    try {
      const response = await fetch(`${API_URL}/api/products?search=${encodeURIComponent(searchTerm)}`);
      if (!response.ok) {
        throw new Error('Failed to fetch products');
      }
      const data = await response.json();
      setSearchResults(data.products || []);
      setCurrentPage(1); // Reset to first page on new search
    } catch (error) {
      console.error('Error searching products:', error);
      alert('Erro ao buscar produtos: ' + error.message);
      setSearchResults([]);
      setCurrentPage(1);
    } finally {
      setLoadingProducts(false);
    }
  };

  // Function to handle product selection
  const handleProductSelect = (product) => {
    setSearchTerm(product.nomeProduto);
    setUnitValue(product.valorUnitario);
    setUnitMeasure(product.unidade);
    setNcm(product.ncm);
    setSelectedProductIpi(product.ipi || 0);
    setSelectedProduct(product);
    setSelectedProductCode(product.code);
    setIsUnitMeasureDisabled(true);
// Disable "Relação de peças" if unit measure is UN, PC, CT, CX, or M3
const disablePieceRelation = ["UN", "PC", "CT", "CX", "M3"].includes(product.unidade);
    setIsPieceRelationDisabled(disablePieceRelation);
    if (disablePieceRelation) {
      setShowPieceRelation(false);
    }
    setShowProductModal(false);
    setProductSearchTerm('');
    setSearchResults([]);
    setCurrentPage(1); // Reset to first page on selection
  };

  // Function to open product search modal
  const handleSearchButtonClick = () => {
    setShowProductModal(true);
    setProductSearchTerm('');
    setSearchResults([]);
  };

  return (
    <div className="space-y-6">
      {/* Item Search Row */}
      <div className="grid grid-cols-1 md:grid-cols-6 gap-6 items-end">
        <div className="md:col-span-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Item: <span className="text-red-500">*</span>
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                if (e.target.value === '') {
                  setUnitValue('');
                  setUnitMeasure('M');
                  setNcm('');
                  setIsUnitMeasureDisabled(false);
                  setIsPieceRelationDisabled(false);
                  setIsProductSelected(false);
                }
              }}
              placeholder="Filtrar por nome / código do item"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleSearchButtonClick}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              title="Buscar produto"
            >
              🔍
            </button>
          </div>
        </div>
      </div>

      {/* Product Search Modal */}
      {showProductModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-md p-4 sm:p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Buscar Produto</h2>
              <button
                onClick={() => setShowProductModal(false)}
                className="text-gray-600 hover:text-gray-900 text-2xl font-bold"
                title="Fechar"
              >
                &times;
              </button>
            </div>
            <input
              type="text"
              value={productSearchTerm}
              onChange={(e) => {
                const value = e.target.value;
                setProductSearchTerm(value);
                if (value.length >= 3) {
                  searchProducts(value);
                } else {
                  setSearchResults([]);
                  setCurrentPage(1);
                }
              }}
              placeholder="Digite o nome ou código do produto (mínimo 3 caracteres)"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
              autoFocus
            />
            {loadingProducts ? (
              <p>Carregando...</p>
            ) : (
              <>
                {/* Pagination Controls */}
                {searchResults.length > itemsPerPage && (
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                      <label className="text-sm font-medium text-gray-700">Itens por página:</label>
                      <select
                        value={itemsPerPage}
                        onChange={(e) => {
                          setItemsPerPage(Number(e.target.value));
                          setCurrentPage(1); // Reset to first page
                        }}
                        className="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                      </select>
                    </div>
                    <div className="text-sm text-gray-700">
                      {(() => {
                        const start = (currentPage - 1) * itemsPerPage + 1;
                        const end = Math.min(currentPage * itemsPerPage, searchResults.length);
                        return `${start} - ${end} de ${searchResults.length}`;
                      })()}
                    </div>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Anterior
                      </button>
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(searchResults.length / itemsPerPage)))}
                        disabled={currentPage === Math.ceil(searchResults.length / itemsPerPage)}
                        className="px-3 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Próximo
                      </button>
                    </div>
                  </div>
                )}
                <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 max-h-96 overflow-y-auto">
        {searchResults.length === 0 ? (
          <tr>
            <td colSpan="3" className="px-6 py-4 text-center text-gray-500">
              Nenhum produto encontrado
            </td>
          </tr>
        ) : (
          searchResults.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map(product => (
            <tr key={product.id} className="hover:bg-gray-100 cursor-pointer" onClick={() => handleProductSelect(product)}>
              <td className="px-6 py-4 whitespace-nowrap">{product.code}</td>
              <td className="px-6 py-4 whitespace-nowrap">{product.nomeProduto}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleProductSelect(product);
                  }}
                  className="text-blue-600 hover:text-blue-900"
                >
                  Selecionar
                            </button>
                          </td>
                        </tr>
          ))
        )}
            </tbody>
              </table>
              </>
            )}
          </div>
        </div>
      )}

      {/* Relação de peças checkbox */}
      <div className="md:col-span-6">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={showPieceRelation}
            onChange={() => setShowPieceRelation(!showPieceRelation)}
            className="form-checkbox"
            disabled={isPieceRelationDisabled}
          />
          <span>Relação de peças</span>
        </label>
      </div>

      {/* Dimension inputs when Relação de peças is checked */}
      {showPieceRelation && (
        <div className="bg-gray-50 p-3 sm:p-4 rounded-md space-y-4">
          <h3 className="text-base sm:text-lg font-medium text-gray-900">Especificações</h3>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Largura:</label>
              <div className="flex">
                <input
                  type="number"
                  value={currentWidth}
                  onChange={(e) => setCurrentWidth(e.target.value)}
                  min="0"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <span className="px-3 py-2 bg-gray-100 border border-l-0 border-gray-300 rounded-r-md text-sm">MM</span>
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Comprimento:</label>
              <div className="flex">
                <input
                  type="number"
                  value={currentLength}
                  onChange={(e) => setCurrentLength(e.target.value)}
                  min="0"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <span className="px-3 py-2 bg-gray-100 border border-l-0 border-gray-300 rounded-r-md text-sm">MM</span>
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Quantidade de Peças:</label>
              <div className="flex">
                <input
                  type="number"
                  value={currentPieces}
                  onChange={(e) => setCurrentPieces(e.target.value)}
                  min="0"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <span className="px-3 py-2 bg-gray-100 border border-l-0 border-gray-300 rounded-r-md text-sm">UN</span>
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Observação:</label>
              <input
                type="text"
                value={observation}
                onChange={(e) => setObservation(e.target.value)}
                placeholder="Observação"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div>
            <button
              type="button"
              onClick={handleAddDimension}
              className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              + Incluir Dimensão
            </button>
          </div>

          {/* Dimensions table */}
          {dimensions.length > 0 && (
            <div className="mt-4 overflow-x-auto -mx-4 sm:mx-0">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-[#f5f1e9]">
                  <tr>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Qtd</th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Comp.</th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider hidden sm:table-cell">Largura</th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider hidden md:table-cell">Altura</th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider hidden lg:table-cell">Obs</th>
                    <th className="px-3 sm:px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Ações</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {dimensions.map((dim, index) => (
                    <tr key={index}>
                      <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm">{dim.pieces}</td>
                      <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm">{dim.length}</td>
                      <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden sm:table-cell">{dim.width || 1000}</td>
                      <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden md:table-cell">40</td>
                      <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden lg:table-cell">{dim.observacao || ''}</td>
                      <td className="px-3 sm:px-6 py-4 whitespace-nowrap">
                        <div className="flex gap-2">
                        <button
                          onClick={() => handleEditDimension(index)}
                          className="text-blue-600 hover:text-blue-900"
                          title="Editar"
                        >
                          ✏️
                        </button>
                        <button
                          onClick={() => handleDeleteDimension(index)}
                          className="text-red-600 hover:text-red-900"
                          title="Excluir"
                        >
                          🗑️
                        </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Quantity, Unit Value, Observation Row */}
      <div className="grid grid-cols-1 md:grid-cols-6 gap-6 items-end">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Quantidade: <span className="text-red-500">*</span>
          </label>
          <div className="flex">
            {!showPieceRelation ? (
              <>
                <input
                  type="number"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  placeholder="0"
                  className="w-3/5 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  step="0.001"
                />
    <select
      value={unitMeasure}
      onChange={(e) => setUnitMeasure(e.target.value)}
      disabled={isUnitMeasureDisabled}
      className="w-2/5 px-2 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
              <option value="UN">UN</option>
              <option value="M">M</option>
              <option value="M2">M2</option>
              <option value="M3">M3</option>
              <option value="PC">PC</option>
              <option value="CT">CT</option>
              <option value="CX">CX</option>
            </select>
              </>
            ) : (
              <div className="flex">
                <input
                  type="number"
                  value={totalMeterage.toFixed(2)}
                  readOnly
                  className="w-3/5 px-3 py-2 border border-gray-300 rounded-l-md bg-gray-100 cursor-not-allowed"
                />
                <span className="w-2/5 px-2 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-100 text-center">M</span>
              </div>
            )}
          </div>
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Valor Unitário:
          </label>
          <input
            type="number"
            value={unitValue}
            onChange={(e) => setUnitValue(e.target.value)}
            placeholder="R$ 0,00"
            step="0.01"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={isProductSelected}
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Observação:
          </label>
          <input
            type="text"
            value={showPieceRelation ? '' : observation}
            onChange={(e) => !showPieceRelation && setObservation(e.target.value)}
            placeholder="Digite aqui caso tenha alguma observação sobre o pedido"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            disabled={showPieceRelation}
          />
        </div>
      </div>

      {/* Add Item Button */}
      <div>
        <button
          onClick={handleAddItem}
          className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          + Incluir
        </button>
      </div>

      {/* Acréscimo, Desconto, Over 1, Over 2 Row with Aplicar button */}
      <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4 mt-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Over</label>
        <div className="flex">
          <input
            type="number"
            value={over1}
            onChange={(e) => setOver1(Number(e.target.value))}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <select
            value={over1Type}
            onChange={(e) => setOver1Type(e.target.value)}
            className="px-2 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="%">%</option>
            <option value="R$">R$</option>
          </select>
        </div>
      </div>
      <button
        type="button"
        onClick={handleAplicar}
        className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        + Aplicar Over
      </button>
      <div className="border-l border-gray-300 h-10"></div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Desconto</label>
        <div className="flex">
          <input
            type="number"
            value={desconto}
            onChange={(e) => setDesconto(Number(e.target.value))}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <select
            value={descontoType}
            onChange={(e) => setDescontoType(e.target.value)}
            className="px-2 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="%">%</option>
            <option value="R$">R$</option>
          </select>
        </div>
      </div>
      <button
        type="button"
        onClick={() => {
          // Apply global desconto to the total over
          setFormData(prev => ({
            ...prev,
            desconto: desconto,
            descontoType: descontoType
          }));
          setDesconto(0);
        }}
        className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        + Aplicar desconto
      </button>
      <div className="border-l border-gray-300 h-10"></div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">% ICMS</label>
        <input
          type="number"
          value={icmsPercentInput}
          onChange={(e) => setIcmsPercentInput(e.target.value)}
          placeholder="0"
          className="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <button
        type="button"
        onClick={handleAplicarICMS}
        className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        + Aplicar ICMS
      </button>
      {/* Recalcular frete button, visible only if any item has freteEmbutidoItem > 0 */}
      {formData.items && formData.items.some(item => item.freteEmbutidoItem && item.freteEmbutidoItem > 0) && (
        <button
          onClick={handleRecalcularFrete}
          className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          title="Recalcular frete"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="inline-block w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Recalcular frete
        </button>
      )}
      </div>


      {/* Itens Table */}
      <div className="mt-6 overflow-x-auto -mx-4 sm:mx-0">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-[#f5f1e9]">
            <tr>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Produto</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Qtd</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden sm:table-cell">Un.</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden md:table-cell">Tabela</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden lg:table-cell">Over</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden xl:table-cell">Líquido</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden xl:table-cell">Frete Un.</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden md:table-cell">Venda</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Total</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider hidden lg:table-cell">ICMS</th>
              <th className="px-3 sm:px-6 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">Ações</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {formData.items?.map((item) => (
              <tr key={item.id}>
              <td className="px-3 sm:px-6 py-4 whitespace-normal break-words max-w-xs text-xs sm:text-sm">{item.produto}</td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm">{item.quantidade.toFixed(3).replace('.', ',')}</td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden sm:table-cell">{item.unidade}</td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden md:table-cell">R$ {(item.valorTabela || 0).toFixed(2)}</td>
                  <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden lg:table-cell">
                    {item.over1Type === '%' ? `${item.over1 || 0}%` : `R$ ${(item.over1 || 0).toFixed(2)}`}
                  </td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden xl:table-cell">
                R$ {(() => {
                  const valorTabela = item.valorTabela || 0;
                  const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
                  return (valorTabela + over).toFixed(2);
                })()}
              </td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden xl:table-cell">
                R$ {(() => {
                  if (item.freteEmbutidoItem) {
                    return (item.freteEmbutidoItem / (item.quantidade || 1)).toFixed(2);
                  }
                  return '0.00';
                })()}
              </td>
                  <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden md:table-cell">
                    R$ {(() => {
                      const valorTabela = item.valorTabela || 0;
                      const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
                      const descontoAmount = item.descontoType === '%' ? over * (item.desconto || 0) / 100 : (item.desconto || 0);
                      const valorLiquido = valorTabela + over - descontoAmount;
                      const freteUnitario = item.freteEmbutidoItem ? item.freteEmbutidoItem / (item.quantidade || 1) : 0;
                      return (valorLiquido + freteUnitario).toFixed(2);
                    })()}
                  </td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm">R$ {(item.valorTotal || 0).toFixed(2)}</td>
              <td className="px-3 sm:px-6 py-4 whitespace-nowrap text-xs sm:text-sm hidden lg:table-cell">{item.icms ? item.icms + "%" : ""}</td>
                <td className="px-3 sm:px-6 py-4 whitespace-nowrap">
                  <div className="flex gap-2">
                <button
                  onClick={() => {
                    // Edit item: load item data into form for editing
                    setEditingItemId(item.id);
                    setSearchTerm(item.produto);
                    setQuantity(item.quantidade);
                    setUnitMeasure(item.unidade);
                    setUnitValue(item.valorTabela);
                    setObservation(item.observacao);
                    setOver1(item.over1 || 0);
                    setOver1Type(item.over1Type || '%');
                    setDesconto(item.desconto || 0);
                    setDescontoType(item.descontoType || '%');
                    setIcmsPercentInput(item.icms ? parseFloat(item.icms) : '');
                    setShowPieceRelation(item.pieceRelation || false);
                    setDimensions(item.dimensions || []);
                    // Reset current dimension inputs when editing
                    setCurrentLength('1000');
                    setCurrentWidth('1000');
                    setCurrentPieces('');
                    setEditIndex(-1);
                  }}
                  className="text-blue-600 hover:text-blue-900"
                  title="Editar"
                >
                  ✏️
                </button>
                <button
                  onClick={() => {
                    if (window.confirm('Tem certeza que deseja apagar este item?')) {
                      // Delete item
                      setFormData(prev => ({
                        ...prev,
                        items: prev.items.filter(i => i.id !== item.id)
                      }));
                      // If the deleted item was being edited, reset the fields
                      if (editingItemId === item.id) {
                        resetFields();
                      }
                    }
                  }}
                  className="text-red-600 hover:text-red-900"
                  title="Excluir"
                >
                  🗑️
                </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

        {/* Desconto - exibido acima do Valor total do Pedido */}
        {formData.desconto > 0 ? (
          <div className="mt-6 bg-gray-100 p-4 rounded-md">
            <div className="flex justify-between items-center">
              <span className="text-lg font-semibold">Desconto:</span>
              <span className="text-lg font-bold text-red-600">
                - {formData.descontoType === '%' ? `${formData.desconto}%` : formatBRL(formData.desconto)}
              </span>
            </div>
          </div>
        ) : null}

        {/* Valor total do Pedido */}
        <div className="mt-6 bg-gray-100 p-4 rounded-md">
          <div className="flex justify-between items-center">
            <span className="text-lg font-semibold">Valor total do Pedido:</span>
            <span className="text-lg font-bold text-green-600">
              R$ {(() => {
                const itemsTotal = formData.items ? formData.items.reduce((sum, item) => sum + (item.valorTotal || 0), 0) : 0;
                const freightToAdd = formData.tipoFrete === 'CIF' ? (formData.freteDestacadoCalculado || 0) : 0;
                const totalOver = formData.items ? formData.items.reduce((sum, item) => {
                  const valorTabela = item.valorTabela || 0;
                  const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
                  return sum + over * item.quantidade;
                }, 0) : 0;
  let descontoAmount = 0;
  if (formData.descontoType === '%') {
    descontoAmount = totalOver * (parseFloat(formData.desconto) || 0) / 100;
  } else {
    descontoAmount = parseFloat(formData.desconto) || 0;
  }
                return (itemsTotal + freightToAdd - descontoAmount).toFixed(2).replace('.', ',');
              })()}
            </span>
          </div>
        </div>

        {/* Total Over */}
      <div className="mt-4 bg-gray-100 p-4 rounded-md">
        {(() => {
          const totalOver = formData.items ? formData.items.reduce((sum, item) => {
            const valorTabela = item.valorTabela || 0;
            const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
            const overAmount = over;
            return sum + overAmount * item.quantidade;
          }, 0) : 0;

  let descontoAmount = 0;
  if (formData.descontoType === '%') {
    descontoAmount = totalOver * (formData.desconto || 0) / 100;
  } else {
    descontoAmount = formData.desconto || 0;
  }

  // Calculate indicators after discount is applied
            const totalOverAfterDiscount = totalOver - descontoAmount;

            const totalOverAfterFreight = totalOverAfterDiscount + parseFloat(formData.ajusteFrete || 0);

            let valorIndicador = 0;
            if (formData.indicadores && formData.indicadores.length > 0) {
              formData.indicadores.forEach(ind => {
                const v = parseFloat(ind.valor);
                const valorNum = isNaN(v) ? 0 : v;
                if (valorNum > 0) {
                  if (ind.valorTipo === '%') {
                    valorIndicador += totalOverAfterDiscount * (valorNum / 100);
                  } else {
                    valorIndicador += valorNum;
                  }
                }
              });
            }

            const totalOverFinal = totalOverAfterFreight;

            return (
              <>
{formData.indicadores && formData.indicadores.filter(ind => {
  const v = parseFloat(ind.valor);
  return !isNaN(v) && v > 0;
}).length > 0 && (
  <div>
    {formData.indicadores.filter(ind => {
      const v = parseFloat(ind.valor);
      return !isNaN(v) && v > 0;
    }).map((ind, idx) => {
      const v = parseFloat(ind.valor);
      const valorNum = isNaN(v) ? 0 : v;
      let deduction = 0;
      if (ind.valorTipo === '%') {
        deduction = totalOverAfterFreight * (valorNum / 100);
      } else {
        deduction = valorNum;
      }
      return (
        <div key={idx} className="flex justify-between items-center mt-2">
          <span className="text-sm">Valor do {ind.nome}:</span>
          <span className="text-sm font-bold text-red-600">
            - {formatBRL(deduction)}
          </span>
        </div>
      );
    })}
  </div>
)}
      {formData.desconto && formData.desconto > 0 && (
        <div className="flex justify-between items-center mt-2">
          <span className="text-sm">Desconto:</span>
          <span className="text-sm font-bold text-red-600">
            - {formatBRL(descontoAmount)}
          </span>
        </div>
      )}
              <div className="flex justify-between items-center">
                <span className="text-lg font-semibold">Total Over:</span>
                <span className="text-lg font-bold text-blue-600">
                  {formatBRL(totalOverFinal)}
                </span>
              </div>
            </>
          );
        })()}
      </div>
    </div>
  );
};

const Step4Freight = ({ formData, setFormData }) => {
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'tipoFrete' && value === 'FOB') {
      setFormData(prev => {
        const updatedItems = prev.items.map(item => {
          const valorTabela = item.valorTabela || 0;
          const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
          const valorLiquido = valorTabela + over;
          return {
            ...item,
            freteEmbutidoItem: 0,
            valorVenda: valorLiquido,
            valorTotal: valorLiquido * item.quantidade
          };
        });
        return {
          ...prev,
          tipoFrete: value,
          valorFrete: '',
          percentualEmbutido: '',
          percentualEmbutidoType: '%',
          freteDestacadoCalculado: 0,
          freteEmbutidoCalculado: 0,
          items: updatedItems
        };
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  // Function to fetch address data from CEP for different address
  const fetchAddressFromCEPForDifferent = async (cep) => {
    if (!cep || cep.length !== 8) return;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        alert('CEP não encontrado. Verifique o CEP digitado.');
        return;
      }

      setFormData(prev => ({
        ...prev,
        logradouroEntregaDiferente: data.logradouro || '',
        bairroEntregaDiferente: data.bairro || '',
        cidadeEntregaDiferente: data.localidade || '',
        estadoEntregaDiferente: data.uf || '',
      }));
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      alert('Erro ao buscar informações do CEP. Tente novamente.');
    }
  };

  // Handle CEP input change with auto-fill for different address
  const handleCEPChangeForDifferent = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    setFormData(prev => ({
      ...prev,
      cepEntregaDiferente: value
    }));

    // Auto-fill when CEP is complete (8 digits)
    if (value.length === 8) {
      fetchAddressFromCEPForDifferent(value);
    }
  };

  // Function to calculate and distribute freight to items
  const handleCalcularFrete = () => {
    const valorFrete = parseFloat(formData.valorFrete || 0);
    const percentualEmbutido = parseFloat(formData.percentualEmbutido || 0);
    const ajusteFrete = parseFloat(formData.ajusteFrete || 0);

    if (valorFrete <= 0) {
      alert('Por favor, insira um valor de frete válido');
      return;
    }

    if (!formData.items || formData.items.length === 0) {
      alert('Adicione itens antes de calcular o frete');
      return;
    }

    // If embedded freight is zero, reset freight values and update items accordingly
    if (percentualEmbutido === 0) {
      const updatedItems = formData.items.map(item => {
        const valorTabela = item.valorTabela || 0;
        const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
        const valorLiquido = valorTabela + over;
        return {
          ...item,
          freteEmbutidoItem: 0,
          valorVenda: valorLiquido,
          valorTotal: valorLiquido * item.quantidade
        };
      });

      setFormData(prev => ({
        ...prev,
        items: updatedItems,
        freteEmbutidoCalculado: 0,
        freteDestacadoCalculado: valorFrete + ajusteFrete
      }));

      alert('Frete calculado com sucesso!');
      return;
    }

    // Calculate embedded freight value
    let freteEmbutido = 0;
    if (formData.percentualEmbutidoType === 'R$') {
      freteEmbutido = percentualEmbutido;
    } else {
      freteEmbutido = valorFrete * (percentualEmbutido / 100);
    }

    // Calculate total value of all items
    const totalValueItems = formData.items.reduce((total, item) => total + item.valorTotal, 0);

    if (totalValueItems <= 0) {
      alert('O valor total dos itens deve ser maior que zero');
      return;
    }

    // Distribute embedded freight proportionally to each item
    const updatedItems = formData.items.map(item => {
      // Calculate base value (valorTabela + over) to avoid adding freight multiple times
      const valorTabela = item.valorTabela || 0;
      const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
      const baseValue = valorTabela + over;
      
      const proportionalFreight = (item.valorTotal / totalValueItems) * freteEmbutido;
      const newUnitValue = baseValue + (proportionalFreight / item.quantidade);
      const newTotalValue = newUnitValue * item.quantidade;

      return {
        ...item,
        valorVenda: newUnitValue,
        valorTotal: newTotalValue,
        freteEmbutidoItem: proportionalFreight
      };
    });

    // Update form data with new item values and freight calculations
    setFormData(prev => ({
      ...prev,
      items: updatedItems,
      freteEmbutidoCalculado: freteEmbutido,
      freteDestacadoCalculado: valorFrete - freteEmbutido + ajusteFrete
    }));

    alert(`Frete distribuído com sucesso! Frete embutido: R$ ${freteEmbutido.toFixed(2)}`);
  };

  // Calculate freight values for display based on type and input
  const valorFretePreview = parseFloat(formData.valorFrete || 0);
  const percentualEmbutidoPreview = parseFloat(formData.percentualEmbutido || 0);
  const ajusteFretePreview = parseFloat(formData.ajusteFrete || 0);

  let freteDestacado = formData.freteDestacadoCalculado || 0;
  let freteEmbutido = formData.freteEmbutidoCalculado || 0;

  // If not calculated yet, show preview calculation
  if (!formData.freteEmbutidoCalculado) {
    if (formData.tipoFrete === 'FOB') {
      freteDestacado = 0;
      freteEmbutido = 0;
    } else if (formData.tipoFrete === 'CIF') {
      if (formData.percentualEmbutidoType === 'R$') {
        freteEmbutido = percentualEmbutidoPreview;
        freteDestacado = valorFretePreview - percentualEmbutidoPreview + ajusteFretePreview;
      } else {
        freteEmbutido = valorFretePreview * (percentualEmbutidoPreview / 100);
        freteDestacado = valorFretePreview - freteEmbutido + ajusteFretePreview;
      }
    }
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Tipo de frete */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipo de frete: <span className="text-red-500"></span>
          </label>
          <div className="flex space-x-4">
            {['CIF', 'FOB'].map(option => (
              <label key={option} className="flex items-center">
                <input
                  type="radio"
                  name="tipoFrete"
                  value={option}
                  checked={formData.tipoFrete === option}
                  onChange={handleInputChange}
                  className="mr-2"
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        {/* Valor de Frete */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Valor de Frete: <span className="text-red-500"></span>
          </label>
          <div className="flex items-center">
            <span className="mr-2">R$</span>
            <input
              type="number"
              name="valorFrete"
              value={formData.valorFrete || ''}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              placeholder="0,00"
              disabled={formData.tipoFrete !== 'CIF'}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Percentual embutido */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Percentual embutido: <span className="text-red-500"></span>
          </label>
          <div className="flex">
            <input
              type="number"
              name="percentualEmbutido"
              value={formData.percentualEmbutido || ''}
              onChange={handleInputChange}
              min="0"
              step="0.001"
              placeholder="0"
              className="w-3/4 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select
              name="percentualEmbutidoType"
              value={formData.percentualEmbutidoType || '%'}
              onChange={handleInputChange}
              className="w-1/4 px-2 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="%">%</option>
              <option value="R$">R$</option>
            </select>
          </div>
        </div>

        {/* Ajuste de Frete */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ajuste de Frete:
          </label>
          <div className="flex items-center">
            <span className="mr-2">R$</span>
             <input
              type="number"
              name="ajusteFrete"
              value={formData.ajusteFrete || ''}
              onChange={handleInputChange}
              min="0"
              step="0.01"
              placeholder="0,00"
              disabled={formData.tipoFrete === 'FOB'}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            />

          </div>
        </div>

        {/* Data prevista de embarque */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Data prevista de embarque: <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            name="dataPrevistaEmbarque"
            value={formData.dataPrevistaEmbarque}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Cidade diferente */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Endereço diferente:
          </label>
          <div className="flex space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="cidadeDiferente"
                value="Sim"
                checked={formData.cidadeDiferente === 'Sim'}
                onChange={handleInputChange}
                className="mr-2"
              />
              Sim
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="cidadeDiferente"
                value="Não"
                checked={formData.cidadeDiferente === 'Não' || !formData.cidadeDiferente}
                onChange={handleInputChange}
                className="mr-2"
              />
              Não
            </label>
          </div>
        </div>

        {/* Endereço de entrega diferente - aparece quando "Sim" for selecionado */}
        {formData.cidadeDiferente === 'Sim' && (
          <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6 p-4 bg-gray-50 rounded-md">
            <h3 className="md:col-span-2 text-lg font-medium text-gray-900 mb-2">Endereço de entrega diferente</h3>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Logradouro</label>
              <input
                type="text"
                name="logradouroEntregaDiferente"
                value={formData.logradouroEntregaDiferente || ''}
                onChange={handleInputChange}
                placeholder="Logradouro"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Número</label>
              <input
                type="text"
                name="numeroEntregaDiferente"
                value={formData.numeroEntregaDiferente || ''}
                onChange={handleInputChange}
                placeholder="Número"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Bairro</label>
              <input
                type="text"
                name="bairroEntregaDiferente"
                value={formData.bairroEntregaDiferente || ''}
                onChange={handleInputChange}
                placeholder="Bairro"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Cidade</label>
              <input
                type="text"
                name="cidadeEntregaDiferente"
                value={formData.cidadeEntregaDiferente || ''}
                onChange={handleInputChange}
                placeholder="Cidade"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">CEP</label>
              <input
                type="text"
                name="cepEntregaDiferente"
                value={formatCEP(formData.cepEntregaDiferente) || ''}
                onChange={handleCEPChangeForDifferent}
                placeholder="CEP"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Estado</label>
              <input
                type="text"
                name="estadoEntregaDiferente"
                value={formData.estadoEntregaDiferente || ''}
                onChange={handleInputChange}
                placeholder="Estado"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Complemento</label>
              <input
                type="text"
                name="complementoEntregaDiferente"
                value={formData.complementoEntregaDiferente || ''}
                onChange={handleInputChange}
                placeholder="Complemento"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        )}

        {/* Botão Calcular frete */}
        <div className="md:col-span-2">
          <button
            type="button"
            onClick={handleCalcularFrete}
            className="bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            $ Calcular frete
          </button>
        </div>

        {/* Frete destacado e embutido */}
        <div className="md:col-span-2 grid grid-cols-2 gap-4">
          <div className="bg-blue-500 text-white p-4 rounded-md">
            <p className="text-sm">Frete destacado</p>
            <p className="text-2xl font-bold">
              R$ {freteDestacado.toFixed(2).replace('.', ',')}
            </p>
          </div>
          <div className="bg-blue-900 text-white p-4 rounded-md">
            <p className="text-sm">Frete embutido</p>
            <p className="text-2xl font-bold">
              R$ {freteEmbutido.toFixed(2).replace('.', ',')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};


const Step5Contract = ({ formData, setFormData }) => {
  const [clauses, setClauses] = useState([]);
  const [selectedClauses, setSelectedClauses] = useState([]);

  useEffect(() => {
    // Fetch clauses from backend API
    const fetchClauses = async () => {
      try {
        const response = await fetch(`${API_URL}/api/clausulas`);
        const data = await response.json();
        if (data.clausulas) {
          // Filtrar apenas cláusulas ativas
          const clausulasAtivas = data.clausulas.filter(c => c.ativa !== false);
          setClauses(clausulasAtivas);
          // Initialize selected clauses based on formData.clausulasContrato or all active clauses
          if (formData.clausulasContrato && formData.clausulasContrato.length > 0) {
            setSelectedClauses(formData.clausulasContrato);
          } else {
            const allActiveClauseIds = clausulasAtivas.map(c => c.id);
            setSelectedClauses(allActiveClauseIds);
            setFormData(prev => ({ ...prev, clausulasContrato: allActiveClauseIds }));
          }
        }
      } catch (error) {
        console.error('Erro ao buscar cláusulas:', error);
      }
    };
    fetchClauses();
  }, [formData.clausulasContrato]);

  const toggleClause = (id) => {
    let updatedSelected;
    if (selectedClauses.includes(id)) {
      updatedSelected = selectedClauses.filter(cid => cid !== id);
    } else {
      updatedSelected = [...selectedClauses, id];
    }
    setSelectedClauses(updatedSelected);
    setFormData(prev => ({ ...prev, clausulasContrato: updatedSelected }));
  };

  const selectAll = () => {
    const allIds = clauses.map(c => c.id);
    setSelectedClauses(allIds);
    setFormData(prev => ({ ...prev, clausulasContrato: allIds }));
  };

  const deselectAll = () => {
    setSelectedClauses([]);
    setFormData(prev => ({ ...prev, clausulasContrato: [] }));
  };

  return (
    <div className="space-y-6">
      <fieldset>
        <legend className="text-lg font-medium text-gray-900 mb-4">Cláusulas do contrato :</legend>
        <div className="flex space-x-4 mb-4">
          <button
            type="button"
            onClick={selectAll}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          >
            Selecionar todos
          </button>
          <button
            type="button"
            onClick={deselectAll}
            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
          >
            Desmarcar todos
          </button>
        </div>
        <div className="space-y-2 max-h-64 overflow-y-auto border border-gray-300 rounded-md p-4">
          {clauses.map(clause => (
            <label key={clause.id} className="flex items-start space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selectedClauses.includes(clause.id)}
                onChange={() => toggleClause(clause.id)}
                className="mt-1"
              />
              <span>{clause.texto}</span>
            </label>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

const Step6Observations = ({ formData, setFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Data prevista da decisão */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Data prevista para follow Up: <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            name="dataPrevistaDecisao"
            value={formData.dataPrevistaDecisao}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Histórico de negociação */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Histórico de negociação:
          </label>
          <textarea
            name="historicoNegociacao"
            value={formData.historicoNegociacao}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Observação */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Observação:
          </label>
          <textarea
            name="observacao"
            value={formData.observacao}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Observação fiscal */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Observação fiscal:
          </label>
          <textarea
            name="observacaoFiscal"
            value={formData.observacaoFiscal}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Observação Logistica */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Observação Logistica:
          </label>
          <textarea
            name="observacaoLogistica"
            value={formData.observacaoLogistica}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        
        />
        </div>

      </div>
    </div>
  );
};

const Step7Summary = ({ formData, setFormData }) => {
  // Calcula Total Over para converter indicadores % em moeda no Step 7
  const totalOver = formData.items ? formData.items.reduce((sum, item) => {
    const valorTabela = item.valorTabela || 0;
    const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
    return sum + over * (item.quantidade || 0);
  }, 0) : 0;

  let descontoAmount = 0;
  if (formData.desconto && formData.desconto > 0) {
    if (formData.descontoType === '%') {
      descontoAmount = totalOver * (formData.desconto / 100);
    } else {
      descontoAmount = formData.desconto;
    }
  }
  const totalOverAfterDiscount = totalOver - descontoAmount;
  const totalOverAfterFreight = totalOverAfterDiscount + parseFloat(formData.ajusteFrete || 0);

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Resumo do pedido</h2>
      <div className="bg-gray-100 p-4 rounded-md space-y-4">
        <div>
          <h3 className="font-semibold">Orçamento</h3>
          
        
      
          <p>Tipo de venda: {formData.tipoVendaMaterial ? 'Material' : ''}  {formData.tipoVendaServico ? '/ Serviço' : ''}</p>
          <p>Vendedor: {formData.vendedor}</p>
          <p>Filial: {formData.filial}</p>
          <p>Indicador(es):</p>
          {(() => {
            return (
              <ul className="list-disc list-inside">
                {formData.indicadores && formData.indicadores.length > 0 ? (
                  formData.indicadores.map((ind, idx) => {
                    const v = parseFloat(ind.valor);
                    const valorNum = isNaN(v) ? 0 : v;
                    let displayValor = '';
                    if (ind.valorTipo === '%') {
                      const deduction = totalOverAfterFreight * (valorNum / 100);
                      displayValor = formatBRL(deduction);
                    } else {
                      // Mantém em moeda quando já for R$
                      displayValor = formatBRL(valorNum);
                    }
                    return (
                      <li key={idx}>
                        {ind.nome} - {displayValor}
                      </li>
                    );
                  })
                ) : (
                  <li>Nenhum indicador adicionado.</li>
                )}
              </ul>
            );
          })()}

        </div>
        <div>
          <h3 className="font-semibold">Cliente</h3>
          <p>Cliente: {formData.cliente}</p>
          <p>Endereço de entrega: {(() => {
            const isDifferent = formData.cidadeDiferente === 'Sim';
            const cidade = isDifferent ? formData.cidadeEntregaDiferente : formData.cidade;
            const estado = isDifferent ? formData.estadoEntregaDiferente : formData.estado;
            const logradouro = isDifferent ? formData.logradouroEntregaDiferente : formData.logradouro;
            const numero = isDifferent ? formData.numeroEntregaDiferente : formData.numero;
            const bairro = isDifferent ? formData.bairroEntregaDiferente : formData.bairro;
            if (cidade && estado && logradouro && numero && bairro) {
              return `${cidade}/ ${estado}, ${logradouro}, ${numero} - ${bairro}`;
            }
            return 'Não informado';
          })()}</p>
          <p>Contribuinte de ICMS: {formData.contribuinteICMS}</p>
          <p>Comprador: {formData.comprador}</p>
          <p>Ordem de compra: {formData.ordemCompra}</p>
        </div>
        <div>
          <h3 className="font-semibold">Forma de Pagamento</h3>
          <p>Condição de pagamento: {formData.condicaoPagamento}</p>
          <p>Forma de pagamento: {formData.formaPagamento}</p>
          <p>Contra aviso: {formData.contraAviso}</p>

        </div>

        <div>
          <h3 className="font-semibold">Frete</h3>
          <p>Tipo de frete: {formData.tipoFrete}</p>
          {(() => {
            const freteDestacado = Number(formData.freteDestacadoCalculado) || 0;
            const freteEmbutido = Number(formData.freteEmbutidoCalculado) || 0;
            // O freteDestacado já inclui o ajusteFrete quando calculado no Step 4
            // Portanto, o valorFreteTotal deve ser freteDestacado + freteEmbutido
            const valorFreteTotal = freteDestacado + freteEmbutido;
            return (
              <>
                <p>Valor do frete: {formatBRL(valorFreteTotal)}</p>
                <p>Frete destacado: {formatBRL(freteDestacado)}</p>
                <p>Frete embutido: {formatBRL(freteEmbutido)}</p>
              </>
            );
          })()}
          <p>Data prevista de embarque: {formData.dataPrevistaEmbarque ? new Date(formData.dataPrevistaEmbarque + 'T00:00:00').toLocaleDateString('pt-BR') : ''}</p>
        </div>

        <div>
          <h3 className="font-semibold mb-2 text-sm sm:text-base">Itens</h3>
          <div className="overflow-x-auto -mx-4 sm:mx-0">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                <th className="px-2 sm:px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Produto</th>
                <th className="px-2 sm:px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Qtd</th>
                <th className="px-2 sm:px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Total</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {formData.items?.map((item) => (
                  <tr key={item.id}>
                    <td className="px-2 sm:px-4 py-2 text-xs sm:text-sm">{item.produto}</td>
                    <td className="px-2 sm:px-4 py-2 text-xs sm:text-sm whitespace-nowrap">{item.quantidade.toFixed(3).replace('.', ',')}</td>
                    <td className="px-2 sm:px-4 py-2 text-xs sm:text-sm font-semibold whitespace-nowrap">{formatBRL(item.valorTotal)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Desconto - exibido acima do Valor total do Pedido */}
        {(() => {
          const totalOver = formData.items ? formData.items.reduce((sum, item) => {
            const valorTabela = item.valorTabela || 0;
            const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
            return sum + over * item.quantidade;
          }, 0) : 0;
          
          let descontoAmount = 0;
          if (formData.descontoType === '%') {
            descontoAmount = totalOver * (formData.desconto || 0) / 100;
          } else {
            descontoAmount = formData.desconto || 0;
          }

          return descontoAmount > 0 ? (
            <div className="mt-6 bg-gray-100 p-4 rounded-md">
              <div className="flex justify-between items-center">
                <span className="text-lg font-semibold">Desconto:</span>
                <span className="text-lg font-bold text-red-600">
                  - {formatBRL(descontoAmount)}
                </span>
              </div>
            </div>
          ) : null;
})()}

{/* Total Over */}
<div className="mt-4 bg-gray-100 p-4 rounded-md">
  {(() => {
    const totalOver = formData.items ? formData.items.reduce((sum, item) => {
      const valorTabela = item.valorTabela || 0;
      const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
      const overAmount = over;
      return sum + overAmount * item.quantidade;
    }, 0) : 0;

    let descontoAmount = 0;
    if (formData.desconto && formData.desconto > 0) {
      if (formData.descontoType === '%') {
        descontoAmount = totalOver * (parseFloat(formData.desconto) / 100);
      } else {
        descontoAmount = parseFloat(formData.desconto) || 0;
      }
    }

    const totalOverAfterDiscount = totalOver - descontoAmount;

    let valorIndicador = 0;
    if (formData.indicadores && formData.indicadores.length > 0) {
      formData.indicadores.forEach(ind => {
        const v = parseFloat(ind.valor);
        const valorNum = isNaN(v) ? 0 : v;
        if (valorNum > 0) {
          if (ind.valorTipo === '%') {
            valorIndicador += totalOverAfterFreight * (valorNum / 100);
          } else {
            valorIndicador += valorNum;
          }
        }
      });
    }

            const totalOverFinal = totalOverAfterFreight - valorIndicador;

    return (
      <>
{formData.indicadores && formData.indicadores.filter(ind => {
  const v = parseFloat(ind.valor);
  return !isNaN(v) && v > 0;
}).length > 0 && (
  <div>
    {(() => {
      const totalOverAfterFreight = totalOverAfterDiscount + parseFloat(formData.ajusteFrete || 0);
      return formData.indicadores.filter(ind => {
        const v = parseFloat(ind.valor);
        return !isNaN(v) && v > 0;
      }).map((ind, idx) => {
        const v = parseFloat(ind.valor);
        const valorNum = isNaN(v) ? 0 : v;
        let deduction = 0;
        if (ind.valorTipo === '%') {
          deduction = totalOverAfterFreight * (valorNum / 100);
        } else {
          deduction = valorNum;
        }
        return (
          <div key={idx} className="flex justify-between items-center mt-2">
            <span className="text-sm">Valor do {ind.nome}:</span>
            <span className="text-sm font-bold text-red-600">
              - {formatBRL(deduction)}
            </span>
          </div>
        );
      });
    })()}
  </div>
)}
                {formData.desconto && formData.desconto > 0 && (
                  <div className="flex justify-between items-center mt-2">
                    <span className="text-sm">Desconto:</span>
                    <span className="text-sm font-bold text-red-600">
                      - {formatBRL(descontoAmount)}
                    </span>
                  </div>
                )}
                <div className="flex justify-between items-center">
                  <span className="text-lg font-semibold">Total Over:</span>
                  <span className="text-lg font-bold text-blue-600">
                    {formatBRL(totalOverFinal)}
                  </span>
                </div>
              </>
            );
          })()}
        </div>
{/* Valor total do Pedido */}
        <div className="mt-6 bg-gray-100 p-4 rounded-md">
          <div className="flex justify-between items-center">
            <span className="text-lg font-semibold">Valor total do Pedido:</span>
            <span className="text-lg font-bold text-green-600">
              R$ {(() => {
                const itemsTotal = formData.items ? formData.items.reduce((sum, item) => sum + (item.valorTotal || 0), 0) : 0;
                const freightToAdd = formData.tipoFrete === 'CIF' ? (formData.freteDestacadoCalculado || 0) : 0;
                const totalOver = formData.items ? formData.items.reduce((sum, item) => {
                  const valorTabela = item.valorTabela || 0;
                  const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
                  return sum + over * item.quantidade;
                }, 0) : 0;
                let descontoAmount = 0;
                if (formData.descontoType === '%') {
                  descontoAmount = totalOver * (formData.desconto || 0) / 100;
                } else {
                  descontoAmount = formData.desconto || 0;
                }
                return (itemsTotal + freightToAdd - descontoAmount).toFixed(2).replace('.', ',');
              })()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const Quotations = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [filiais, setFiliais] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [indicadores, setIndicadores] = useState([]);

  useEffect(() => {
    const fetchFiliais = async () => {
      try {
        const response = await fetch(`${API_URL}/api/admin/filiais`);
        const data = await response.json();
        setFiliais(data.filiais || []);
      } catch (error) {
        console.error('Error fetching filiais:', error);
      }
    };

    const fetchUsuarios = async () => {
      try {
        const response = await fetch(`${API_URL}/api/usuarios?cargo=Vendedor`);
        const data = await response.json();
        console.log('Fetched usuarios:', data.usuarios);
        setUsuarios(data.usuarios || []);
      } catch (error) {
        console.error('Error fetching usuarios:', error);
      }
    };

    const fetchIndicadores = async () => {
      try {
        const response = await fetch(`${API_URL}/api/indicadores`);
        const data = await response.json();
        setIndicadores(data.indicadores || []);
      } catch (error) {
        console.error('Error fetching indicadores:', error);
      }
    };

    fetchFiliais();
    fetchUsuarios();
    fetchIndicadores();
  }, []);
  const getInitialFormData = () => {
    return {
      tipoCliente: '',
      cpf: '',
      cnpj: '',
      inscricaoEstadual: '',
      inscricaoMunicipal: '',
      tipoVendaMaterial: true,
      tipoVendaServico: false,
      setor: '',
      canalVenda: '',
      vendedor: '',
      filial: '',
      obra: '',
      orcamentista: '',
      possuiEspecificador: '',
      engenheirado: '',
      operacaoFiscal: '',
      condicaoPagamento: '',
      tabelaPreco: '',
      formaPagamento: '',
      contraAviso: 'Não',
      leasing: '',
      instalacaoFrigorifica: '',
      destinacaoMercadoria: '',
      cliente: '',
      enderecoEntrega: '',
      comprador: '',
      ordemCompra: '',
      indicadores: [],
      contribuinteICMS: 'Não',
      icmsPercent: '',
      segmentacao: '',
      subSegmentacao: '',
      microSegmentacao: '',
      comoConheceu: '',
      preFabricado: '',
      items: [],
      tipoFrete: 'FOB',
      percentualEmbutido: '',
      dataDesejadaEmbarque: '',
      dataPrevistaEmbarque: '',
      transportadorRedespacho: '',
      cidadeDiferente: '',
      justificativa: '',
      clausulasContrato: [],
      dataPrevistaDecisao: '',
      historicoNegociacao: '',
      observacao: '',
      observacaoFiscal: '',
      observacaoLogistica: '',
      localizador: ''
    };
  };

  const [formData, setFormData] = useState(getInitialFormData);
  const [errors, setErrors] = useState({});

  if (!user) {
    return <div className="max-w-7xl mx-auto p-4 text-center">You must be logged in to access this page.</div>;
  }

  const validateStep = () => {
    const newErrors = {};
    switch (currentStep) {
      case 1:
        if (!formData.vendedor) newErrors.vendedor = 'Vendedor é obrigatório';
        if (!formData.filial) newErrors.filial = 'Filial é obrigatório';
        if (!formData.condicaoPagamento) newErrors.condicaoPagamento = 'Condição de pagamento é obrigatória';
        if (!formData.formaPagamento) newErrors.formaPagamento = 'Forma de pagamento é obrigatória';
        break;
      case 2:
        // Step 2 (Cliente) - Cliente é obrigatório
        if (!formData.cliente) {
          newErrors.cliente = 'Cliente é obrigatório';
        }
        break;
      case 3:
        // Step 3 (Itens) - pelo menos um item é obrigatório
        if (!formData.items || formData.items.length === 0) {
          newErrors.items = 'Adicione pelo menos um item';
          alert('Adicione pelo menos um item');
        }
        break;
      case 4:
        // Step 4 (Frete) - somente a Data prevista de embarque é obrigatória
        if (!formData.dataPrevistaEmbarque) {
          newErrors.dataPrevistaEmbarque = 'Data prevista de embarque é obrigatória';
          alert('Data prevista de embarque é obrigatória');
        }
        break;
      case 6:
        // Step 6 (Observações) - Data prevista para follow Up é obrigatória
        if (!formData.dataPrevistaDecisao) {
          newErrors.dataPrevistaDecisao = 'Data prevista para follow Up é obrigatória';
          alert('Data prevista para follow Up é obrigatória');
        }
        break;
      default:
        break;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validação final para envio: todos os obrigatórios de todos os steps
  const validateAllSteps = () => {
    const errs = {};
    const missing = [];

    // Step 1 obrigatórios
    if (!formData.vendedor) { errs.vendedor = 'Vendedor é obrigatório'; missing.push('Vendedor'); }
    if (!formData.filial) { errs.filial = 'Filial é obrigatório'; missing.push('Filial'); }
    if (!formData.condicaoPagamento) { errs.condicaoPagamento = 'Condição de pagamento é obrigatória'; missing.push('Condição de pagamento'); }
    if (!formData.formaPagamento) { errs.formaPagamento = 'Forma de pagamento é obrigatória'; missing.push('Forma de pagamento'); }

    // Step 2: Cliente
    if (!formData.cliente) { errs.cliente = 'Cliente é obrigatório'; missing.push('Cliente'); }

    // Step 3: pelo menos um item
    if (!formData.items || formData.items.length === 0) { errs.items = 'Adicione pelo menos um item'; missing.push('Pelo menos um item (Step 3)'); }

    // Step 4: Data prevista de embarque
    if (!formData.dataPrevistaEmbarque) { errs.dataPrevistaEmbarque = 'Data prevista de embarque é obrigatória'; missing.push('Data prevista de embarque'); }

    // Step 6: Data prevista para follow Up
    if (!formData.dataPrevistaDecisao) { errs.dataPrevistaDecisao = 'Data prevista para follow Up é obrigatória'; missing.push('Data prevista para follow Up'); }

    // Atualiza erros (mantém os existentes)
    setErrors(prev => ({ ...prev, ...errs }));

    if (missing.length > 0) {
      alert('Preencha os campos obrigatórios: ' + missing.join(', '));
      return false;
    }
    return true;
  };

  const goToNextStep = () => {
    if (validateStep()) {
      setCurrentStep(prev => Math.min(prev + 1, STEPS.length));
    }
  };

  const goToPreviousStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const handleSubmit = async () => {
    // No Step 7 só pode enviar se todos os obrigatórios de todos os steps estiverem preenchidos
    if (!validateAllSteps()) {
      return;
    }
    try {
      // Calculate Valor total do pedido
      const itemsTotal = formData.items ? formData.items.reduce((sum, item) => sum + (item.valorTotal || 0), 0) : 0;
      const freightToAdd = formData.tipoFrete === 'CIF' ? (formData.freteDestacadoCalculado || 0) : 0;
      const valorTotalPedido = itemsTotal + freightToAdd;

      // Calculate Total Over (bruto)
      const totalOver = formData.items ? formData.items.reduce((sum, item) => {
        const valorTabela = item.valorTabela || 0;
        const over = item.over1Type === '%' ? valorTabela * (item.over1 || 0) / 100 : (item.over1 || 0);
        return sum + over * item.quantidade;
      }, 0) : 0;

      const response = await fetch(`${API_URL}/api/quotations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          valorTotalPedido,
          totalOver,
          version: 1,
          createdBy: user?.email || 'unknown'
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit quotation');
      }

      const result = await response.json();
      alert('Cotação enviada com sucesso! ID: ' + result.quotationId);
      navigate('/admin/quotations/consultar');
    } catch (error) {
      console.error('Error submitting quotation:', error);
      alert('Erro ao enviar cotação: ' + error.message);
    }
  };









  return (
    <div className="max-w-7xl mx-auto p-4">
      {/* Navigation */}
      <nav className="flex flex-wrap items-center gap-2 sm:gap-4 mb-8">
        {STEPS.map(step => (
          <div key={step.id} className="flex items-center space-x-2">
            <div
              className={`p-2 rounded-full cursor-pointer ${
                currentStep === step.id ? 'bg-blue-600 text-white' : 'bg-gray-300 text-gray-600'
              }`}
              onClick={() => setCurrentStep(step.id)}
            >
              {step.icon}
            </div>
            <span className={`text-xs sm:text-sm font-medium ${currentStep === step.id ? 'text-blue-600' : 'text-gray-600'} hidden sm:inline`}>
              {step.id}. {step.name}
            </span>
            {step.id < STEPS.length && <span className="text-gray-400"> </span>}
          </div>
        ))}
      </nav>

      {/* Step Content */}
      <div className="bg-white p-4 sm:p-6 rounded-md shadow-md">
{currentStep === 1 && <Step1BudgetTax formData={formData} setFormData={setFormData} errors={errors} setErrors={setErrors} filiais={filiais} setFiliais={setFiliais} usuarios={usuarios} setUsuarios={setUsuarios} />}
        {currentStep === 2 && <Step2Client formData={formData} setFormData={setFormData} errors={errors} />}
        {currentStep === 3 && <Step3Items formData={formData} setFormData={setFormData} errors={errors} />}
        {currentStep === 4 && <Step4Freight formData={formData} setFormData={setFormData} />}
        {currentStep === 5 && <Step5Contract formData={formData} setFormData={setFormData} />}
        {currentStep === 6 && <Step6Observations formData={formData} setFormData={setFormData} />}
        {currentStep === 7 && <Step7Summary formData={formData} setFormData={setFormData} />}
      </div>

      {/* Navigation Buttons */}
      <div className={`flex flex-col sm:flex-row mt-6 gap-3 ${currentStep === 1 ? 'sm:justify-end' : 'sm:justify-between'}`}>
        {currentStep > 1 && (
          <button
            onClick={goToPreviousStep}
            className="bg-yellow-700 text-white py-2 px-6 rounded-md hover:bg-yellow-800 focus:outline-none focus:ring-2 focus:ring-yellow-500"
          >
            Anterior
          </button>
        )}
        {currentStep < STEPS.length && (
          <button
            onClick={goToNextStep}
            className="bg-blue-600 text-white py-2 px-6 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Próximo
          </button>
        )}
        {currentStep === STEPS.length && (
          <button
            onClick={handleSubmit}
            className="bg-green-600 text-white py-2 px-6 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            Enviar
          </button>
        )}
      </div>
    </div>
  );
};

export default Quotations;
